// Mouse and touch presses hide the focus ring; the next navigation key shows it again.
// react-aria treats focus moved by code as keyboard focus, so without this a click can light a
// ring. base.css clears the ring colors while the root carries data-input="pointer".
const NAVIGATION_KEYS = new Set([
  'Tab',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
  'PageUp',
  'PageDown',
  'Escape',
  'F6',
]);

export function trackInputModality(root: HTMLElement = document.documentElement) {
  const onPointer = () => root.setAttribute('data-input', 'pointer');
  const onKey = (event: KeyboardEvent) => {
    if (NAVIGATION_KEYS.has(event.key)) root.removeAttribute('data-input');
  };
  document.addEventListener('pointerdown', onPointer, true);
  document.addEventListener('keydown', onKey, true);
  return () => {
    document.removeEventListener('pointerdown', onPointer, true);
    document.removeEventListener('keydown', onKey, true);
  };
}
